import { Strings } from "../../utils/strings";
import { isMobile } from "react-device-detect";
import { IS_HIDE_TOP_BAR } from "../../utils/constants";
import TopBar from "../../components/topBar/TopBar";
import { useMatchListStore } from "../../stores/StoreContext";
import { useCourtBooking } from "../../context/courtBookingContext";
import { AllMatchlist } from "./widgets/AllMatchlist";
import { ExpandableFAB } from "../../components/floatingActionButton/expandableFAB/ExpandableFAB";
import { useExapandableFabActions } from "../../hooks/useExapandableFabActions";
import { useEffect, useRef } from "react";

const MatchList = () => {
  const matchListStore = useMatchListStore();
  const { onLogOut } = useCourtBooking();
  const hasFetched = useRef(false);

  const { ExpandableFabButtons, renderServiceLocationModal } =
    useExapandableFabActions();

  useEffect(() => {
    if (!hasFetched.current) {
      matchListStore.getMatchList();
      hasFetched.current = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div
      style={{
        paddingBottom: 30,
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        position: "relative", // Added for positioning the FAB
      }}>
      {!localStorage.getItem(IS_HIDE_TOP_BAR) ? (
        <TopBar
          isBack={isMobile}
          onLogout={() => {
            matchListStore.modalData = {
              visible: true,
              title: Strings.LOGOUT,
              children: Strings.LOGOUT_WARNING,
              btnText: Strings.LOGOUT,
              btnVariant: "outline-danger",
              headerIcon: <div />,
              onClose: () => {
                matchListStore.modalData = undefined;
              },
              onAccept: () => {
                matchListStore.modalData = undefined;
                onLogOut();
              },
            };
          }}
          // onBookPro={onCoachAvailability}
        />
      ) : (
        <div style={{ height: 0 }} />
      )}
      <AllMatchlist />
      <ExpandableFAB options={ExpandableFabButtons} />
      {renderServiceLocationModal}
    </div>
  );
};

export default MatchList;
